import { FutureDelivery } from './future-deliveries-types.js'
import { FutureDeliveriesDTO } from '@cloudsuite/cs-ordering-defs'

export const parseFutureDeliveriesResponse = (body: FutureDeliveriesDTO): FutureDelivery[] => {
  return body.future_deliveries.map(item => new FutureDelivery(item.delivery_date))
}
